import { jsx as r } from "react/jsx-runtime";

import { forwardRef as o } from "react";

import { INPUT_VARIANT_CLASSES as a } from "../../constants/index.js";

import t from "../../utils/classNames/index.js";

let e = !1;

const i = o((({variant: o, className: i, ...s}, n) => {
    const c = o && a[o];
    return "production" !== process.env.NODE_ENV && (void 0 === s["aria-invalid"] || e || (console.warn("You should not pass aria-invalid prop to <Checkbox /> directly. It is computed from variant === error."), 
    e = !0)), r("input", {
        ref: n,
        type: "checkbox",
        "aria-invalid": "error" === o ? "true" : "false",
        className: t("checkbox", c, i),
        ...s
    });
}));

export { i as default };
//# sourceMappingURL=index.js.map
